module.exports = __webpack_public_path__ + "static/media/spoonerism-task (4).82b684c8.mp3";